const CustomerLangs = {
  customerList: {
    title: "Danh sách khách hàng",
  },
  customerDetail: {
    title: "Thông tin khách hàng {{name}}",
  },
  customerAdd: {
    title: "Thêm khách hàng",
  },
  customerUpdate: {
    title: "Cập nhật khách hàng",
  },
  form: {
    info: "Thông tin khách hàng",
    name: "Tên khách hàng",
    email: "Email",
    phone: "Số điện thoại",
    address: "Địa chỉ khách hàng",
    ward: "Phường",
    district: "Quận",
    city: "Thành phố",
    customer_type: "Loại khách hàng",
    company_id: "Danh sách công ty",
    helperCompany:
      "Chỉ chọn công ty nếu khách hàng là doanh nghiệp (hoặc có công ty)",
  },
  success: {
    customerAdd: "Thêm khách hàng thành công",
    customerUpdate: "Cập nhật khách hàng thành công",
  },
  error: {
    customerList: "lấy danh sách khách hàng lỗi",
    customerAdd: "Thêm khách hàng lỗi",
    customerUpdate: "Cập nhật khách hàng lỗi",
  },
};
export default CustomerLangs;
